import { BasketListItem } from './basket-store/basket-list-parser.js'
import { BasketNameTooLong, DeliveryPolicy } from 'components/ordering/acl/internal-types.js'


export class BasketCreatedEvent extends Event {
  static type = 'basket-created' as const

  constructor() {
    super(BasketCreatedEvent.type, { bubbles: true, composed: true })
  }
}

export class BasketFormResetEvent extends Event {
  static type = 'basket-creator-reset' as const

  constructor() {
    super(BasketFormResetEvent.type, { bubbles: true, composed: true })
  }
}

export { ProductAddedEvent } from 'components/ordering/add-to-basket/events.js'

export class ProductRemovedEvent extends Event {
  static type = 'product-removed' as const

  constructor() {
    super(ProductRemovedEvent.type, { bubbles: true, composed: true })
  }
}

export class BasketFormFinishedEvent extends Event {
  static type = 'basket-form-finished' as const

  name: string
  selectedDeliveryPolicy: DeliveryPolicy

  constructor(name: string, policy: DeliveryPolicy) {
    super(BasketFormFinishedEvent.type, { bubbles: true, composed: true })
    this.name = name
    this.selectedDeliveryPolicy = policy
  }
}


export class SelectDeliveryPolicyEvent extends Event {
  static type = 'select-delivery-policy' as const

  selectedDeliveryPolicy: DeliveryPolicy

  constructor(selected_delivery_policy: DeliveryPolicy) {
    super(SelectDeliveryPolicyEvent.type, { bubbles: true, composed: true })
    this.selectedDeliveryPolicy = selected_delivery_policy
  }
}


export class BasketNameChosenEvent extends Event {
  static type = 'basket-name-chosen' as const

  name: string

  constructor(name: string) {
    super(BasketNameChosenEvent.type, { bubbles: true, composed: true })
    this.name = name
  }
}


export class BasketNameValidationErrorEvent extends Event {
  static type = 'basket-name-validation-error' as const

  reason: BasketNameTooLong

  constructor(reason: BasketNameTooLong) {
    super(BasketNameValidationErrorEvent.type, { bubbles: true, composed: true })
    this.reason = reason
  }
}


export class BasketChangedEvent extends Event {
  static type = 'basket-changed' as const

  constructor() {
    super(BasketChangedEvent.type, { bubbles: true, composed: true })
  }
}

export class BasketTransferFormResetEvent extends Event {
  static type = 'basket-transfer-reset' as const

  constructor() {
    super(BasketTransferFormResetEvent.type, { bubbles: true, composed: true })
  }
}

/**
 * @deprecated
 * No longer in use because of changed requirements, and should remain that way.
 */
export class BasketContactFormSkipped extends Event {
  static type = 'basket-contact-skipped' as const
  skipAllowed: boolean

  constructor(skipAllowed: boolean) {
    super(
      BasketContactFormSkipped.type, {
        bubbles: true,
        composed: true,
      }
    )
    this.skipAllowed = skipAllowed
  }
}

export class BasketContactFormSubmitted extends Event {
  static type = 'basket-contact-submitted' as const
  success: boolean

  constructor(success: boolean) {
    super(
      BasketContactFormSubmitted.type, {
        bubbles: true,
        composed: true,
      }
    )
    this.success = success
  }
}

export class SelectingBasketEvent extends Event {
  static type = 'selecting-basket' as const

  targetBasket: BasketListItem

  constructor(targetBasket: BasketListItem) {
    super(SelectingBasketEvent.type, { bubbles: true, composed: true, })

    this.targetBasket = targetBasket
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [BasketCreatedEvent.type]: BasketCreatedEvent,
    [BasketFormResetEvent.type]: BasketFormResetEvent,
    [BasketTransferFormResetEvent.type]: BasketTransferFormResetEvent,
    [BasketFormFinishedEvent.type]: BasketFormFinishedEvent,
    [SelectDeliveryPolicyEvent.type]: SelectDeliveryPolicyEvent,
    [BasketNameChosenEvent.type]: BasketNameChosenEvent,
    [BasketNameValidationErrorEvent.type]: BasketNameValidationErrorEvent,
    [BasketChangedEvent.type]: BasketChangedEvent,
    [SelectingBasketEvent.type]: SelectingBasketEvent,
  }
}
